<template>
<v-container grid-list- id="Breadcrumb">


    <v-layout align-center justify-space-between>
      <v-breadcrumbs  :items="breadcrumbList"></v-breadcrumbs>

      <v-btn v-if="userLoggedIn" v-on:click="SignOut()" text justify-end color="primary">Sign Out</v-btn>
    </v-layout>
  </v-container>
</template>

<script>
import firebase from "firebase"
export default {
  name: "Breadcrumb",
  data() {
    return {
      breadcrumbList: [],
      userLoggedIn:true
    };
  },
  watch: {
    $route() {
      this.updateList();
    }
  },
  mounted() {
    this.updateList();

  },
  beforeUpdate(){
    if(this.$route.name=="Login"){
      this.userLoggedIn=false;
    }
    else{
      this.userLoggedIn=true;
    }
    console.log(this.$route.name);
  },
  methods: {
    routeTo(pRouteTo) {
      if (this.breadcrumbList[pRouteTo].link)
        this.$router.replace(this.breadcrumbList[pRouteTo].link);

    },
    updateList() {
      this.breadcrumbList = this.$route.meta.breadcrumb;
    },
    SignOut(){
      console.log("signing out");
      let self=this;
    firebase.auth().signOut().then(function(){
        // this.$toasted.show("Signed out successfully");
        console.log("Signed out.")
        self.$router.go();
        // this.$router.push("/");
      }).catch(function(error){
        console.log("error signing out:: "+error)
      });
    },
  }
};
</script>

<style scoped>
</style>
